import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from './tooltip-v2';
import { FormattedMessage } from 'react-intl';

export const NotificationTooltip = ({ title, children, anchorClickCB, anchor, exitCB, show, arrowPlacement, id }) => {
  return (
    <div className="tooltip-container">
      <Tooltip
        placement="bottom"
        tooltipClass="notification-popover"
        anchorClickCB={anchorClickCB}
        anchorType="custom"
        exitCB={exitCB}
        showX
        managedByParentVal={show}
        customAnchor={anchor}
        arrowPlacement={arrowPlacement}
        id={id}
      >
        <div className="notification-tooltip-body">
          <div className="text-white text-small heavy">
            <span className="new-container bg-green-200">
              <FormattedMessage
                id="hosting.notification_tooltip.small_text"
                defaultMessage="NEW"
              />
            </span>
          </div>
          <div className="h6">{title}</div>
          <div className="text-gray-dark">
            {children}
          </div>
        </div>
      </Tooltip>
    </div>
  );
};

NotificationTooltip.propTypes = {
  title: PropTypes.string,
  children: PropTypes.object,
  anchorClickCB: PropTypes.func,
  anchor: PropTypes.object,
  exitCB: PropTypes.func,
  show: PropTypes.bool,
  arrowPlacement: PropTypes.object,
  id: PropTypes.string
};
